import { utils, Box, ListSubheader } from '@costar/theme-ui';
import React from 'react';
import sortOrder from './sort-order.esm.js';
import { getGroupOptions, getOptionKey } from './utils.esm.js';

function renderGroupOptions(options, renderItem, selectionClick, handleClose, selection, groupKey) {
  return Object.keys(options).sort(sortOrder(options)).map(function (key, idx) {
    var next = options[key];
    var groupOptions = getGroupOptions(next);
    return utils.isNotEmptyObject(groupOptions) ? /*#__PURE__*/React.createElement(Box, {
      as: "li",
      key: "list-item-group-".concat(idx)
    }, /*#__PURE__*/React.createElement(Box, {
      as: "ul",
      p: 0,
      bg: "inherit",
      borderTop: "neutralsGray"
    }, /*#__PURE__*/React.createElement(ListSubheader, null, "".concat(next === null || next === void 0 ? void 0 : next.label)), renderGroupOptions(groupOptions, renderItem, selectionClick, handleClose, selection, getOptionKey(key, groupKey)))) : renderItem(selectionClick, handleClose, selection, function (key) {
      return options ? options[key] : "".concat(key);
    }, groupKey)(key, idx);
  });
}

export default renderGroupOptions;
//# sourceMappingURL=render-group-options.esm.js.map
